import { Button, cn, SignatureIcon, Text } from '@viapeople/components'

export type FormSignatureProps = {
	signature: string
	actionTitle: string
	isSigned: boolean
	disabled?: boolean
	readOnly?: boolean
	onSign: () => void
	onAction: () => void
	signatureTimestamp?: Date
	timestampUnavailableText?: string
}

export function FormSignature({
	signature,
	actionTitle,
	onAction,
	disabled,
	isSigned,
	onSign,
	readOnly,
	signatureTimestamp,
	timestampUnavailableText,
}: FormSignatureProps) {
	return (
		<div className='flex gap-4 bg-neutral-100 rounded-lg p-6 justify-between'>
			<div className='flex gap-2 items-center self-start '>
				<SignatureIcon />
				<Text variant='h6' weight='semibold'>
					{readOnly ? actionTitle : `Sign ${actionTitle ? `and ${actionTitle}` : ''}`}
				</Text>
			</div>
			<div className='flex items-center gap-6'>
				{/* biome-ignore lint/a11y/noStaticElementInteractions: role is conditionally applied when not readOnly */}
				<div
					role={!readOnly ? 'button' : undefined}
					tabIndex={!readOnly ? 0 : undefined}
					className={cn(
						'border-b border-neutral-200 min-w-100 flex justify-center px-4 relative',
						!isSigned && !readOnly && 'cursor-pointer',
					)}
					onClick={readOnly ? undefined : onSign}
					onKeyDown={
						!readOnly
							? (e) => {
									if (e.key === 'Enter' || e.key === ' ') onSign()
								}
							: undefined
					}>
					{isSigned ? (
						<Text variant='none' className='font-sacramento text-4xl pt-2'>
							{signature}
						</Text>
					) : (
						<Text variant='large' className='text-neutral-500 pt-3 pb-2'>
							Signature
						</Text>
					)}
					{isSigned && (signatureTimestamp || timestampUnavailableText) && (
						<Text variant='hint' className='absolute bottom-[-20px]'>
							{signatureTimestamp ? signatureTimestamp.toLocaleString() : timestampUnavailableText}
						</Text>
					)}
				</div>

				{!readOnly && (
					<Button variant='primary' className='capitalize' disabled={!isSigned || disabled} onClick={onAction}>
						{actionTitle ? actionTitle : 'Continue'}
					</Button>
				)}
			</div>
		</div>
	)
}
